import EditBtns from "../EditBtns";
import "./index.less";

export default {
  name: "EditableBox",
  components: {
    EditBtns
  },
  props: {
    mode: String,
    position: {
      type: String,
      default: "topRight"
    },
    hideHover: {
      type: Boolean,
      default: false
    },
    includeBtns: {
      type: Array,
      default: () => ["confirm", "edit", "delete", "add"]
    }
  },
  data() {
    return {
      isEdit: false,
      moreBtns: []
    };
  },
  computed: {
    positionStyle() {
      const positionStyleObj = {
        topLeft: {
          left: 0,
          top: "-26px"
        },
        topRight: {
          right: 0,
          top: "-26px"
        },
        rightTop: {
          right: "-" + (this.editBtns.length * 23 + 3) + "px",
          top: 0
        }
      };
      return positionStyleObj[this.position];
    },
    editBtns() {
      const includeBtns = this.includeBtns.map(key => {
        if (Array.isArray(key)) {
          this.moreBtns = key;
          return "more";
        }
        return key;
      });
      if (this.isEdit) {
        this.moreBtns = [];
        return ["confirm"];
      }
      return includeBtns.filter(key => !["confirm"].includes(key));
    }
  },

  mounted() {
    window.addEventListener("mouseup", this.checkOtherArea);
  },
  beforeDestory() {
    window.removeEventListener("mouseup", this.checkOtherArea);
  },

  methods: {
    // 检查是否点击其他区域
    checkOtherArea(e) {
      if (this.$refs.editableBox && !this.$refs.editableBox.contains(e.target) && this.isEdit) {
        // this.isEdit = false;
        this.handleConfirm();
      }
    },
    setIsEdit(isEdit) {
      this.isEdit = isEdit;
    },
    handleSetup() {
      this.isEdit = false;
      this.$emit("onSetup");
    },
    handleConfirm() {
      this.isEdit = false;
      this.$emit("onConfirm");
    },
    handleEdit(e) {
      e && e.stopPropagation();
      this.isEdit = true;
      this.$emit("onEdit");
    },
    handleDelete() {
      this.isEdit = false;
      this.$emit("onDelete");
    },
    handleAdd() {
      this.$emit("onAdd");
    },
    handleMore(command, data) {
      this.$emit("onMore", command, data);
    }
  },

  render() {
    const { mode, isEdit, positionStyle, hideHover, moreBtns, editBtns, $slots, $scopedSlots } = this;
    const children = $scopedSlots.default ? $scopedSlots.default({ isEdit }) : $slots.default;

    if (mode === "edit") {
      return (
        <span class="wrapper">
          <div
            class={{
              "editable-box": true,
              "is-edit": isEdit,
              "hide-hover": hideHover
            }}
            ref="editableBox"
            onDblclick={this.handleEdit}
          >
            {children}
            <div class="edit-btns-wrapper" style={positionStyle}>
              <edit-btns
                editBtns={editBtns}
                moreBtns={moreBtns}
                onOnSetup={this.handleSetup}
                onOnEdit={this.handleEdit}
                onOnAdd={this.handleAdd}
                onOnDelete={this.handleDelete}
                onOnConfirm={this.handleConfirm}
                onOnMore={this.handleMore}
              ></edit-btns>
            </div>
          </div>
        </span>
      );
    }
    return children;
  }
};
